<template>
  <div class="modal--wrapper" :class="{'modal-open': modalOpenState}">
    <div class="modal" :class="{'modal-picture': extra && extra.picture}">
      <div class="modal--title">
        <div class="modal--header-picture" v-if="extra && extra.picture">
          <img :src="`${extra.picture}`+ '?w=' + Math.min((window.innerWidth - 40), 700) + '&h=260&crop-to-fit'" alt="" />
        </div>
        <div class="modal--title-text" v-if="extra">
          {{extra.text.name}}
        </div>
        <div v-if="extra !== null" class="row">
          <p class="col price" id="left" v-if="extra !== null">{{extra.price.parsed}} €</p>
          <p class="col price" v-if="extra.type === 'PERSON'">{{$t('extras.person')}}</p>
          <p class="col price" v-if="extra.type === 'DAY'">{{$t('extras.day')}}</p>
          <p class="col price" v-if="extra.type === 'HOUR'">{{$t('extras.hour')}}</p>
          <p class="col price" v-if="extra.type === 'EACH'">{{$t('extras.each')}}</p>
        </div>
        <div class="modal--title-actions">
          <modal-close-btn @click="closeModal" />
        </div>
      </div>
      <div class="modal--content modal--content-extra" v-if="extra">
        <p v-html="extra.text.description"></p>
      </div>
      <div class="modal--content" v-else></div>
    </div>
  </div>
</template>

<script>
  import loader from './loader.component';
  import {mapState} from "vuex";
  import ModalCloseBtn from "./modal-close-btn";

  export default {
    name: "extras-modal",
    components: {ModalCloseBtn, loader},
    async mounted() {
      window.addEventListener('app:extras-modal.open', () => {
        this.openModal();
      });
    },
    data() {
      return {
        modalOpenState: false,
        window: window,
      }
    },
    computed: {
      ...mapState({
        loading: s => s.client.loading,
        extra: s => s.extrasModal.extra,
      })
    },
    methods: {
      closeModal() {
        this.modalOpenState = false;
      },
      openModal() {
        this.modalOpenState = true;
      }
    },
  };
</script>

<style scoped>
@media only screen and (max-width: 480px) {
  .modal.modal-picture .modal--header-picture {
    height: 260px;
  }
  .modal.modal-picture .modal--header-picture img {
    min-height: unset;
  }
}
.row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-top: 0;
}
.col {
  width: auto;
  padding: 0;
  margin: 16px 0 0 0;
}
.price {
  font-family: 'Abhaya Libre', serif;
  font-weight: 500;
  color: #787896;
  text-align: center;
  font-size: 18px;
  line-height: 18px;
}

#left {
  margin-left: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/extras-modal.vue